import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilService, VariablesService } from 'src/app/shared/services';

@Component({
  selector: 'app-sip-top-banner-v2',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sip-top-banner-v2.component.html',
  styleUrls: ['./sip-top-banner-v2.component.scss']
})
export class SipTopBannerV2Component implements OnInit {

  userData;
  totalDonations;

  constructor(
    public util: UtilService,
    public vars: VariablesService
  ) {}

  ngOnInit(): void {
    this.vars.userData.subscribe(user => {
      this.userData = user;
      this.totalDonations = this.userData?.aggdonationall?.funds === 0 ? false : true;
    });
  }

}
